import * as React from "react";

export const ChatIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({
  color = "#A1A7BA",
  ...rest
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    color={color}
    {...rest}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.25"
      d="M16.666 13.333a1.333 1.333 0 0 1-1.333 1.334H6.552c-.354 0-.693.14-.943.39l-1.468 1.468a.473.473 0 0 1-.808-.334V5.333A1.333 1.333 0 0 1 4.666 4h10.667a1.333 1.333 0 0 1 1.333 1.333z"
    ></path>
  </svg>
);
